import { AppThunk } from '../../../store/rootReducer';
import * as ruler2dActions from '../actions/ruler2d.actions';
import { isUpdatingRuler2dSelector } from '../selectors/ruler2d.selectors';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';

export const startRuler2d =
  (timestamp: number, voltage: number): AppThunk =>
  async (dispatch, getState) => {
    const isUpdatingRuler2d = isUpdatingRuler2dSelector(getState());
    const isRuler2dActive = isToolActiveSelector(Tool.ruler2d)(getState());

    if (!isUpdatingRuler2d && isRuler2dActive) {
      dispatch(
        ruler2dActions.setBoundary({
          xBoundary: 'timestampEnd',
          yBoundary: 'voltageEnd',
          timestamp,
          voltage,
        }),
      );
    }
  };
